import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import API_URL from '../config';
import { findLocalDevCompany, isLocalDevAuthEnabled } from '../utils/localDevAuth';
import { clearAuthMessage, clearStoredAuth, getApiErrorMessage } from '../utils/authSession';

const CompanySelection = () => {
    const navigate = useNavigate();
    const [selectedCompany, setSelectedCompany] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    const handleCompanyChange = (e) => {
        setSelectedCompany(e.target.value);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        const companyName = selectedCompany.trim();
        const companyPassword = password.trim();

        try {
            const response = await axios.post(`${API_URL}/api/verify-company-password/`, {
                company_name: companyName,
                password: companyPassword,
            });

            if (response.data.success) {
                clearAuthMessage();
                clearStoredAuth({ preserveCompanyId: false });
                localStorage.setItem('company_id', response.data.company_id);
                navigate(`/login?companyId=${response.data.company_id}`);
            }
        } catch (err) {
            const localCompany = isLocalDevAuthEnabled()
                ? findLocalDevCompany(companyName, companyPassword)
                : null;
            if (localCompany) {
                clearAuthMessage();
                clearStoredAuth({ preserveCompanyId: false });
                localStorage.setItem('company_id', localCompany.id);
                navigate(`/login?companyId=${localCompany.id}`);
                return;
            }

            const errorMessage = getApiErrorMessage(err, {
                fallback: 'Unable to verify company right now. Please try again shortly.',
                sessionFallback: 'Unable to verify company. Please check the company name and password.',
            });
            setError(errorMessage);
}
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-background px-4 overflow-x-hidden">
            <div className="card w-full max-w-md p-5 sm:p-6">
                <h2 className="mb-4 text-center text-xl font-bold tracking-tight text-text sm:mb-6 sm:text-2xl">Select Company</h2>
                {error && <div className="alert-error mb-4 text-center">{error}</div>}
                <form onSubmit={handleSubmit}>
                    <input
                        type="text"
                        name="username"
                        style={{ display: 'none' }}
                        autoComplete="username"
                        aria-hidden="true"
                    />
                    <div className="mb-3 sm:mb-4">
                        <label className="block text-text mb-1 sm:mb-2 text-sm sm:text-base" htmlFor="company">Company</label>
                        <input
                            id="company"
                            value={selectedCompany}
                            onChange={handleCompanyChange}
                            className="input-field w-full p-2 sm:p-3 text-text text-sm sm:text-base"
                            placeholder="Enter the Company Name"
                            required
                        />
                    </div>
                    <div className="mb-3 sm:mb-4">
                        <label className="block text-text mb-1 sm:mb-2 text-sm sm:text-base" htmlFor="password">Password</label>
                        <input
                            type="password"
                            id="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="input-field w-full p-2 sm:p-3 text-text text-sm sm:text-base"
                            placeholder="Enter the Company Password"
                            required
                            autoComplete="new-password"
                        />
                    </div>
                    <button
                        type="submit"
                        className="primary-btn w-full p-2 sm:p-3 text-sm sm:text-base"
                    >
                        Proceed to Login
                    </button>
                    <button
                        type="button"
                        onClick={() => navigate('/')}
                        className="secondary-btn mt-3 w-full p-2 sm:p-3 text-sm sm:text-base"
                    >
                        Back to Home
                    </button>
                </form>
            </div>
        </div>
    );
};

export default CompanySelection;
